import { MenuItem, Select } from '@material-ui/core'
import { Strings } from '../assets/res/en'
export default function addressDataColumn(addressTypes, countryMenus, stateMenus) {

    let mappedAddress = addressTypes.map(item => ({ [item.val]: item.text }))
    let addressTypeItems = Object.assign({}, ...mappedAddress)
    const getStates = idCountry => stateMenus.filter(state => state.idCountry === idCountry) ?? []
    const addressCols = [
        { title: Strings.CARD_ADDRESSTYPE, field: 'idAddressType', lookup: addressTypeItems, validate: rowData => rowData.idAddressType ? true : false },
        { title: Strings.CARD_HOME_NUMBER, field: 'number' },
        {
            title: Strings.CARD_STREET, field: 'street', validate: rowData => rowData.street ? true : false,
            cellStyle: { minWidth: 300 },
            headerStyle: { minWidth: 300 },
        },
        { title: Strings.CARD_COLONY, field: 'colony', validate: rowData => rowData.colony ? true : false },
        { title: Strings.CARD_MUNICIPALITY, field: 'municipality', validate: rowData => rowData.municipality ? true : false },
        { title: Strings.CARD_CITY, field: 'city', validate: rowData => rowData.city ? true : false },
        {
            title: Strings.CARD_COUNTRY, field: 'idCountry',
            render: (rowdata) => countryMenus.filter(country => country.val === rowdata.idCountry)[0].text,
            validate: rowData => rowData.idCountry && rowData.idCountry ? true : false,
            editComponent: ({ value, onRowDataChange, rowData }) => (
                <Select
                    value={value}
                    onChange={(event) => {
                        onRowDataChange({
                            ...rowData,
                            idCountry: (event.target.value) ?? "",
                            idState: "",
                        })
                    }}
                >
                    {countryMenus.map((country) => (
                        <MenuItem key={country.val} value={country.val}>
                            {country.text}
                        </MenuItem>
                    ))}
                </Select>
            )
        },
        {
            title: Strings.CARD_STATE,
            field: 'idState',
            render: (rowdata) => stateMenus.filter(state => state.val === rowdata.idState)[0].text,
            validate: rowData => rowData.idState && rowData.idState > 0 ? true : false,
            editComponent: ({ value, onChange, rowData }) => (
                <Select
                    value={value}
                    onChange={(event) => {
                        onChange(event.target.value)
                    }}
                >
                    {
                        getStates(rowData.idCountry).map((state) => (
                            <MenuItem key={state.val} value={state.val}>
                                {state.text}
                            </MenuItem>
                        ))
                    }
                </Select>
            ),
        },
        { title: Strings.CARD_ZIPCODE, field: 'zipCode', validate: rowData => rowData.zipCode ? true : false },
        {
            title: Strings.CARD_BETWEENSTREETS, field: 'betweenStreets', 
            cellStyle: { minWidth: 250 },
            headerStyle: { minWidth: 250 },
        },
        { title: Strings.CARD_INTERIOR, field: 'interior' },
        {
            title: Strings.CARD_COMMENT, field: 'comment',
            cellStyle: { minWidth: 250 },
            headerStyle: { minWidth: 250 },
        },
        { title: Strings.PREFFERED, field: 'preferred', type: 'boolean' }
    ]
    return { addressCols }
}